// start changes
import TagManager from "@sooro-io/react-gtm-module";

const tagManagerArgs = {
  // TODO: if this needs to be dynamic, make it a build-time configurable var.
  // Right now (2024-11-08) we only have one GTM ID, so it's hardcoded.
  gtmId: "GTM-TFD6ZS8",
};

let isInitted = false;

export const initTagManager = (): void => {
  if (!__DEV__ && !isInitted) {
    TagManager.initialize(tagManagerArgs);
    isInitted = true;
  }
};

interface UInfo {
  userId: string;
  accountId: string;
}

export const setUinfoCookieForTagManager = (uinfo: UInfo): void => {
  const stringified = JSON.stringify(uinfo);
  const encoded = btoa(stringified);
  const withExtraQuotes = `"${encoded}"`;
  document.cookie = `uinfo=${withExtraQuotes}; Domain=.mightier.com; Path=/; max-age=31536000;`;
};
